require('../../sass/components/_inputPassword.scss');

import {Input} from './Input';

export const PasswordInput = {
    name: 'PasswordInput',
    inheritAttrs: false,
    components: {
        Input
    },
    props: {
        isInvalid: Boolean,
        value: String,
        disabled: Boolean,
        defaultIsPasswordVisible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isPasswordVisible: this.defaultIsPasswordVisible
        }
    },
    computed: {
        rootClasses() {
            return [
                'input-password',
                this.isPasswordVisible ? 'input-password--revealed' : 'input-password--hidden'
            ];
        },
        inputType() {
            return this.isPasswordVisible ? 'text' : 'password';
        },
    },
    template: `
        <div :class="rootClasses">
            <Input :type="inputType"
                    :value="value"
                    class="input-password__input"
                    v-on="$listeners"
                    :disabled="disabled"
                    :isInvalid="isInvalid"
                    v-bind="$attrs"/>
                    
           <button class="input-password__button" type="button" :disabled="disabled" tabindex="-1" @click.prevent="isPasswordVisible=!isPasswordVisible"></button>
        </div>
    `
};